// src/fakeAuth.js

// Dummy users for testing
const users = [
    { role: "hr", email: "hr@example.com", password: "hr123" },
    { role: "manager", email: "manager@example.com", phone: "1234567890", password: "manager123" },
    { role: "employee", email: "employee@example.com", password: "emp123" },
  ];
  
  export const loginUser = (role, credentials) => {
    const user = users.find((u) => u.role === role);
    if (!user) return false;
  
    if (role === "hr" && user.email === credentials.email && user.password === credentials.password) {
      localStorage.setItem("role", role);
      return true;
    }
  
    if (role === "manager" && user.email === credentials.email && user.phone === credentials.phone && user.password === credentials.password) {
      localStorage.setItem("role", role);
      return true;
    }
  
    if (role === "employee" && user.email === credentials.email && user.password === credentials.password) {
      localStorage.setItem("role", role);
      return true;
    }
  
    return false;
  };
  
  export const getUserRole = () => localStorage.getItem("role");
  export const logoutUser = () => localStorage.removeItem("role");
  